import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryCodeTab,
} from '@/layout/state/state';
import { matchCodeUrl } from '@/constants/urls';
import DatasetActions from '../containers/DatasetActions';
import { closeDataset } from '../actions';
import DatasetPanel from '../components/DatasetPanel';

export default (urls, access) => ({
  ...tabTemplate('dataset', DatasetPanel, matchCodeUrl(urls), DatasetActions),
  ...tabCloser('closeDatasetTab', closeDataset),
  ...tabIcons('table'),
  access,
  componentState: ({ args, url }) => categoryCodeTab(url, args[2]),
  order: 205,
});
